function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLapset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ikonitFamily") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M30.7,10A5.71,5.71,0,1,1,25,4.3,5.71,5.71,0,0,1,30.7,10Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1,12.38a1.85,1.85,0,0,1,.6,2.5l-7.82,9.88a1.83,1.83,0,0,1-2.56,0h0a1.84,1.84,0,0,1-.59-2.5l7.81-9.88a1.83,1.83,0,0,1,2.56,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9,12.4a1.84,1.84,0,0,0-.59,2.5l7.81,9.88a1.83,1.83,0,0,0,2.56,0h0a1.83,1.83,0,0,0,.59-2.49L16.46,12.4a1.83,1.83,0,0,0-2.56,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,28.19A1.9,1.9,0,0,1,24,30l-.26,14a1.9,1.9,0,0,1-2,1.73h0a1.9,1.9,0,0,1-2-1.8l.26-14a1.89,1.89,0,0,1,2-1.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.09,28.18a1.92,1.92,0,0,0-2,1.82l.2,14a1.88,1.88,0,0,0,2,1.72h0a1.9,1.9,0,0,0,2-1.81l-.2-14a1.9,1.9,0,0,0-2-1.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.17,25.23c0,4.43-2.77,8-6.18,8s-6.18-3.59-6.18-8,2.77-8,6.18-8S31.17,20.81,31.17,25.23Z",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLapset);
export default __webpack_public_path__ + "static/media/lapset.09cb3c747652cf240a2fcf8abae78d5f.svg";
export { ForwardRef as ReactComponent };